import { S3Client } from "@aws-sdk/client-s3";

// Ensure the variables exist, otherwise the S3 Client will throw errors
const accountId = process.env.REACT_APP_R2_ACCOUNT_ID || "";
const accessKeyId = process.env.REACT_APP_R2_ACCESS_KEY_ID || "";
const secretAccessKey = process.env.REACT_APP_R2_SECRET_ACCESS_KEY || "";

export const r2Client = new S3Client({
  region: "auto",
  endpoint: `https://${accountId}.r2.cloudflarestorage.com`,
  credentials: {
    accessKeyId,
    secretAccessKey,
  },
  forcePathStyle: true,
});

export const R2_BUCKET_NAME = process.env.REACT_APP_R2_BUCKET_NAME;
export const R2_PUBLIC_URL = process.env.REACT_APP_R2_PUBLIC_URL; // e.g. https://pub-xxxxxx.r2.dev
